/**
 * requestNotification — ask the server to send a notification (MS-D11, PB-07).
 *
 * The browser names a type and the ids of the record it's about; the
 * `onNotificationRequestCreated` Cloud Function checks the account, works out
 * the recipients from Firestore and sends email / bell / push. The browser
 * never supplies an address or any text (SH-D4). Fields must match the
 * `notificationRequests` create rule in `firestore.rules`.
 */
import { addDoc, collection, serverTimestamp } from 'firebase/firestore'
import { auth, db } from '../firebase'

export interface NotificationRequestIds {
  invitation: { invitationId: string }
  tenant_scan_required: { equipmentId: string; tenantId: string }
  tenant_assigned: { propertyId: string; tenantId: string }
}

export type NotificationRequestType = keyof NotificationRequestIds

export async function requestNotification<T extends NotificationRequestType>(
  type: T,
  ids: NotificationRequestIds[T]
): Promise<string> {
  const uid = auth.currentUser?.uid
  if (!uid) throw new Error('requestNotification: not signed in')
  const ref = await addDoc(collection(db, 'notificationRequests'), {
    type,
    requestedBy: uid,
    createdAt: serverTimestamp(),
    ...ids,
  })
  console.log('[NotificationRequest] queued', { type, id: ref.id, ...ids })
  return ref.id
}
